module.exports = __webpack_public_path__ + "img/107.a9b6b41b.jpg";